// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2I_fT","info":"UpdateTermsInfo_info__EZkNm"};